var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'value-input-text mr-md-1': true,
    'w-100 px-3 mb-1': _vm.$vuetify.breakpoint.smAndDown,
  }},[_c('v-text-field',{attrs:{"value":_vm.value,"clearable":"","dense":"","placeholder":"Input a text","outlined":"","height":"30px"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }